import * as React from 'react';
import { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, TextField, TextFieldVariants } from '@mui/material';
import { renderHelpText } from './renderHelpText';
import { InputAdornment } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';

export interface NumberInputFieldProps {
    value?: number,
    id?: string,
    type?: 'number',
    disabled?: boolean, // readOnly and greyed out
    readOnly?: boolean,
    prepend?: string,
    append?: string,
    max?: number,
    min?: number,
    step?: number,
    label?: string,
    helpText?: string,
    style?: React.CSSProperties,
    inputStyle?: React.CSSProperties,
    variant?: TextFieldVariants | 'nobox',
    onChange?: (value?: number) => void,
    onClick?: () => void,
}

export const NumberInputField = (props: NumberInputFieldProps) => {
    const {
        value,
        id,
        type,
        max,
        min,
        step,
        label,
        helpText,
        prepend,
        append,
        disabled,
        readOnly,
        style,
        inputStyle,
        variant = 'outlined',
        onChange,
        onClick,
    } = props;

    const [cleared, setCleared] = useState(false)
    const [showHelp, setShowHelp] = useState(false)

    const _onChange = (value: string): void => {
        if (!onChange) return;
        
        if(!/^-?\d+((\.|,)\d+)?$/.test(value)) {
            setCleared(true)
            return onChange(undefined)
        }
        else {
            setCleared(false)
            const float = parseFloat(value)
            if(max !== undefined && float > max) return onChange(max);
            if(min !== undefined && float < min) return onChange(min);
            onChange(float);
        }
    }

    const valueComputed = cleared || value === undefined || Number.isNaN(value) ? '' : Math.round(value*100)/100

    return (<>
        <TextField
            id={id ? `${id}-input` : undefined}
            style={style}
            type={type || 'number'}
            value={valueComputed}
            label={helpText
                ? <div>{label} <IconButton size="small" onClick={() => setShowHelp(true)}><HelpIcon/></IconButton></div>
                : label}
            disabled={disabled}
            slotProps={{
                input: {
                    startAdornment: prepend ? <InputAdornment position="start">{prepend}</InputAdornment> : undefined,
                    endAdornment: append ? <InputAdornment position="end">{append}</InputAdornment> : undefined,
                    inputProps: {
                        style: inputStyle,
                        max,
                        min,
                        step,
                        onClick: onClick,
                        readOnly: disabled || readOnly,
                    }
                },
                inputLabel: {
                    shrink: true,
                },
            }}
            onChange={e => _onChange(e.target.value)}
            onClick={onClick}
            sx={variant === 'nobox' ? {
                "& .MuiInput-underline:before": { borderBottom: "none" },
                // "& .MuiInput-underline:after": { borderBottom: "none" },
                // "& .MuiInput-underline:hover:not(.Mui-disabled):before": { borderBottom: "none" }
            } : undefined}
            variant={variant === 'nobox' ? 'standard' : variant}
            size="small"
            fullWidth
        />

        {(helpText?.length &&
            <Dialog open={showHelp} onClose={() => setShowHelp(false)}>
                <DialogTitle>{label}</DialogTitle>
                <DialogContent>{renderHelpText(helpText)}</DialogContent>
            </Dialog>
        ) || undefined}
    </>);
}
